module.exports = __webpack_public_path__ + "static/img/v1.c63b56d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/v1.png
// module id = jwAM
// module chunks = 1